import React, { createContext, useContext } from 'react';

import { QuizAnswer } from 'store/modules/quizManager';

import useQuizLogic from './useQuizLogic';

export type QuizStep = React.ComponentType<any>;

interface QuizContextType {
  currentStep: number;
  currentStepComponent: QuizStep;
  nextStep: () => void;
  prevStep: () => void;
  resetQuiz: () => void;
  responses: Record<string, any>;
  setQuiz: ({
    stepName,
    answer,
  }: {
    stepName: string;
    answer: QuizAnswer;
  }) => void;
  totalSteps: number;
}

const QuizContext = createContext<QuizContextType>({} as QuizContextType);

export const useQuizContext = () => {
  const context = useContext(QuizContext);

  return context;
};

interface QuizProviderProps {
  steps: QuizStep[];
  quizId: string;
  children: React.ReactNode;
}

export const QuizProvider = ({
  steps,
  quizId,
  children,
}: QuizProviderProps) => {
  const quizLogic = useQuizLogic({ steps, quizId });

  return (
    <QuizContext.Provider value={quizLogic}>{children}</QuizContext.Provider>
  );
};
